<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>
  	<v-layout row wrap>
  		<v-flex xs12></v-flex>
	  	<v-flex xs6 md3 pa-2>
	      <v-card>
	        <v-card-title>
	          <v-flex xs6>
	          	<v-icon class="green--text" size="72">person</v-icon>
	          </v-flex>
	    	  <v-flex xs6 class="text-xs-right">
		        <h3 class="display-2 grey--text">{{customers}}</h3>
		        <h6 class="caption grey--text text--lighten-1 text-uppercase">Customers</h6>
	    	  </v-flex>
	        </v-card-title>
	        <v-divider></v-divider>
	        <v-card-actions>
	          <div class="body-1 grey--text text--lighten-1 text-uppercase">Total Customers</div>
	        </v-card-actions>
	      </v-card>
	    </v-flex>
	    <v-flex xs6 md3 pa-2>
	      <v-card>
	        <v-card-title>
	          <v-flex xs6>
	          	<v-icon class="amber--text" size="72">person</v-icon>
	          </v-flex>
	    	  <v-flex xs6 class="text-xs-right">
		        <h3 class="display-2 grey--text">{{agents}}</h3>
		        <h6 class="caption grey--text text--lighten-1 text-uppercase">Agents</h6>
	    	  </v-flex>
	        </v-card-title>
	        <v-divider></v-divider>
	        <v-card-actions>
	          <div class="body-1 grey--text text--lighten-1 text-uppercase">Total Agents</div>
	        </v-card-actions>
	      </v-card>
	    </v-flex>
	    <v-flex xs6 md3 pa-2>
	      <v-card>
	        <v-card-title>
	          <v-flex xs6>
	          	<v-icon class="deep-orange--text" size="72">shopping_cart</v-icon>
	          </v-flex>
	    	  <v-flex xs6 class="text-xs-right">
		        <h3 class="display-2 grey--text">{{orders}}</h3>
		        <h6 class="caption grey--text text--lighten-1 text-uppercase">Orders</h6>
	    	  </v-flex>
	        </v-card-title>
	        <v-divider></v-divider>
	        <v-card-actions>
	          <div class="body-1 grey--text text--lighten-1 text-uppercase">Today's Orders</div>
	        </v-card-actions>
	      </v-card>
	    </v-flex>
	    <v-flex xs6 md3 pa-2>
	      <v-card>
	        <v-card-title>
	          <v-flex xs6>
	          	<v-icon class="pink--text" size="72">shopping_cart</v-icon>
	          </v-flex>
	    	  <v-flex xs6 class="text-xs-right">
		        <h3 class="display-2 grey--text">{{invoices}}</h3>
		        <!-- <h6 class="caption grey--text text--lighten-1 text-uppercase">Proforma Invoices</h6> -->
	    	  </v-flex>
	        </v-card-title>
	        <v-divider></v-divider>
	        <v-card-actions>
	          <div class="body-1 grey--text text--lighten-1 text-uppercase">Today's Proformas</div>
	        </v-card-actions>
	      </v-card>
	    </v-flex>
    </v-layout>

    <v-layout pt-3 v-if="!isMobileApp">
	    <v-flex xs12>
        <v-card>
          <v-card-title>
            <div class="title">Recent Orders</div>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :loading="processing"
            :items="items"
            item-key="id"
            hide-actions
            disable-initial-sort
          >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <tr is="sales-list-item" v-bind:item="props.item" :viewMode="ordersViewMode"></tr>
            </template>
            <template slot="no-data" v-if="!processing && !items.length">
              <v-alert :value="true" color="error" icon="warning">
                Sorry, nothing to display here :(
              </v-alert>
            </template>
          </v-data-table>

          <v-pagination @loadPage="loadPage" />

        </v-card>
      </v-flex>
    </v-layout>
   
  </v-flex>
</template>

<script>

  import SalesListItem from './SalesListItem'

  export default {
    name: 'Dashboard',
    data () {
      return {
        processing: false,
        customers: 0,
        agents: 0,
        orders: 0,
        invoices: 0,
        ordersViewMode: true,
        items: [],
        headers: [
          { text: 'Order ID', value: 'code'},
          { text: 'Order Date', value: 'added_time'},
          { text: 'Order Type', value: 'type', sortable: false},
          { text: 'Customer/Franchisee', value: 'customer_name', sortable: false},
          { text: 'Branch', value: 'retailer_name'},
          { text: 'Total (Rs.)', value: 'grandtotal', align: 'right'},
          { text: 'Status', value: 'status', align: 'center', sortable: false }
        ]
      }
    },

    methods: {

      loadPage () {

        let api_path = this.config.apis.getInvoices.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)

        api_path += '?confirmed=true'

        if (this.isShippingManager) {
          let statuses = [this.config.invoiceStatus.approved, this.config.invoiceStatus.shipped, this.config.invoiceStatus.delivered]
          api_path += '&status=' + statuses.join(',')
        }
        else if(this.isShippingStaff) {
          let statuses = [this.config.invoiceStatus.shipped, this.config.invoiceStatus.delivered]
          api_path += '&status=' + statuses.join(',')
        }

        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (response && response.data && response.data.success && response.data.data && response.data.data.items) {
              this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
              this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },
      
      getCustomersCount () {
        return this.axios.get(this.config.apis.getCustomersCount)
      },

      getAgentsCount () {
        return this.axios.get(this.config.apis.getAgentsCount)
      },

      getOrdersCount () {
        let api_path = this.config.apis.getOrdersCount

        if (!this.isDistributor) {
          api_path += `?retailer=${this.retailerId}`
        }
        return this.axios.get(api_path)
      },

      getInvoicesCount () {
        let api_path = this.config.apis.getInvoicesCount

        if (!this.isDistributor) {
          api_path += `?retailer=${this.retailerId}`
        }
        return this.axios.get(api_path)
      }

    },

    created () {
      this.$store.commit('setBreadcrumbs', [])
      this.$store.commit('setPageTitle', this.isMobileApp ? `Welcome ${this.loggedInUser.first_name}!` : '')
    },

    mounted () {

      this.processing = true

      Promise.all([this.getCustomersCount(), this.getAgentsCount(), this.getOrdersCount(), this.getInvoicesCount()])
        .then(([customersResponse, agentsResponse, ordersResponse, invoicesResponse]) => {
            this.processing = false
            this.customers = this.isSuccessResponse(customersResponse) ? customersResponse.data.data.count : 0
            this.agents = this.isSuccessResponse(agentsResponse) ? agentsResponse.data.data.count : 0
            this.orders = this.isSuccessResponse(ordersResponse) ? ordersResponse.data.data.count : 0
            this.invoices = this.isSuccessResponse(invoicesResponse) ? invoicesResponse.data.data.count : 0
        })
        .catch((error) => {
            this.processing = false
        })
    },
    
    components: {
      'sales-list-item': SalesListItem
    }

  }
</script>
